








































// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';

const cssPrefix = 'provision-tile';
@Component({
  components: {
    SwIcon,
  },
})
export default class ProvisionTile extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ type: String })
  tileHeader: '';

  @Prop({ type: String })
  tileIcon: '';

  @Prop({ type: Boolean })
  disabled: boolean;
}
